import i18n, { getLocale, setI18nLanguage } from '@/lang/index.js'

async function langMiddleware (to, from, next) {
  // const app = inject('app')
  const paramsLocale = to.params?.locale || from.params?.locale || getLocale(i18n)
  const defaultLocale = getLocale(i18n)
  const langExists = i18n.languages.some(lang => lang.locale === paramsLocale && lang.active)
  const locale = langExists ? paramsLocale : defaultLocale

  if (!langExists) {
    next({
      replace: true,
      name   : to?.name || 'Home',
      params : { locale: locale },
      query  : to?.query || {}
    })
    return
  }

  await setI18nLanguage(i18n, paramsLocale)
  next()
}

export default langMiddleware
